/* ============================================
   Mamahub Advertorial — Main JS (v6)
   ~120 lines, no dependencies
   ============================================ */
(function () {
  'use strict';

  // --- 1. Reading Progress Bar ---
  function initProgress() {
    var bar = document.getElementById('ed-progress');
    if (!bar) return;
    window.addEventListener('scroll', function () {
      var h = document.documentElement.scrollHeight - window.innerHeight;
      bar.style.width = (h > 0 ? (window.scrollY / h) * 100 : 0) + '%';
    }, { passive: true });
  }

  // --- 2. Sticky Bottom Bar (appears after 400px scroll) ---
  function initStickyBar() {
    var bar = document.getElementById('ed-sticky-bar');
    if (!bar) return;
    window.addEventListener('scroll', function () {
      bar.classList.toggle('visible', window.scrollY > 400);
    }, { passive: true });
  }

  // --- 3. Video Play/Pause ---
  function initVideos() {
    var players = document.querySelectorAll('[data-video]');
    players.forEach(function (container) {
      var video = container.querySelector('video');
      var overlay = container.querySelector('.ed-video-card__play');
      if (!video || !overlay) return;

      container.addEventListener('click', function () {
        if (video.paused) {
          // Pause all others
          document.querySelectorAll('[data-video] video').forEach(function (v) {
            if (v !== video) {
              v.pause();
              var o = v.closest('[data-video]').querySelector('.ed-video-card__play');
              if (o) o.classList.remove('ed-hidden');
            }
          });
          video.muted = false;
          video.play();
          overlay.classList.add('ed-hidden');
        } else {
          video.pause();
          overlay.classList.remove('ed-hidden');
        }
      });
    });
  }

  // --- 4. Cart Drawer ---
  function initCart() {
    var toggle = document.getElementById('ed-cart-toggle');
    var drawer = document.getElementById('ed-cart-drawer');
    var overlay = document.getElementById('ed-cart-overlay');
    var close = document.getElementById('ed-cart-close');
    if (!toggle || !drawer || !overlay) return;

    function open() {
      drawer.classList.add('ed-cart-drawer--open');
      overlay.classList.add('ed-cart-overlay--open');
      document.body.style.overflow = 'hidden';
    }
    function shut() {
      drawer.classList.remove('ed-cart-drawer--open');
      overlay.classList.remove('ed-cart-overlay--open');
      document.body.style.overflow = '';
    }
    toggle.addEventListener('click', open);
    overlay.addEventListener('click', shut);
    if (close) close.addEventListener('click', shut);
    document.addEventListener('keydown', function (e) {
      if (e.key === 'Escape' && drawer.classList.contains('ed-cart-drawer--open')) shut();
    });
  }

  // --- 5. Copy Link ---
  function initCopyLink() {
    var btn = document.getElementById('ed-copy-link');
    if (!btn) return;
    btn.addEventListener('click', function () {
      navigator.clipboard.writeText(window.location.href).then(function () {
        btn.textContent = 'Copied!';
        setTimeout(function () { btn.textContent = 'Copy Link'; }, 2000);
      });
    });
  }

  // --- 6. FAQ Accordion ---
  function initFAQ() {
    var items = document.querySelectorAll('.ed-faq-item');
    items.forEach(function (item) {
      var q = item.querySelector('.ed-faq-item__q');
      if (!q) return;
      q.addEventListener('click', function () {
        var wasOpen = item.classList.contains('ed-faq-item--open');
        // Close all
        items.forEach(function (i) { i.classList.remove('ed-faq-item--open'); });
        // Toggle clicked
        if (!wasOpen) item.classList.add('ed-faq-item--open');
      });
    });
    // Open first by default
    if (items.length) items[0].classList.add('ed-faq-item--open');
  }

  // --- 7. Share Buttons (Facebook + Pinterest) ---
  function initShareButtons() {
    var fbBtn = document.getElementById('ed-share-fb');
    var pinBtn = document.getElementById('ed-share-pin');
    var url = encodeURIComponent(window.location.href);
    var title = encodeURIComponent(document.title);

    if (fbBtn) {
      fbBtn.addEventListener('click', function (e) {
        e.preventDefault();
        window.open('https://www.facebook.com/sharer/sharer.php?u=' + url, '_blank', 'width=600,height=400');
      });
    }

    if (pinBtn) {
      pinBtn.addEventListener('click', function (e) {
        e.preventDefault();
        window.open('https://pinterest.com/pin/create/button/?url=' + url + '&description=' + title, '_blank', 'width=600,height=400');
      });
    }
  }

  // --- Init ---
  document.addEventListener('DOMContentLoaded', function () {
    initProgress();
    initStickyBar();
    initVideos();
    initCart();
    initCopyLink();
    initFAQ();
    initShareButtons();
  });
})();
